import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import '@/assets/css/nprogress.css'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import { getRunEnv } from '@/utils/env'
import store from '@/store/baseStore'
import { isWeiXin, isQQBrowser, isDingtalk, isHLApp, isTHSApp, toggleDebug } from '@/utils'
import qs from 'qs'
import { removeTheme } from '@/utils/theme'
import { thsI18NJsBridge } from '@fs/jsbridge'

const { VUE_APP_ENV = 'sit' } = process.env
if (VUE_APP_ENV !== 'prod') {
    toggleDebug(true)
}

Vue.use(VueRouter)

NProgress.configure({ showSpinner: false })

/**
 * 实例化router
 * @param { Array } options.routes 项目的路由数组
 * @param { Function } options.handleBeforeEach 自定义路由beforeEach逻辑
 * @param { Function } options.handleAfterEach 自定义路由afterEach逻辑
 * @returns { Object } router实例
 */
export default function initRouter(options = {}) {
    // 网厅入口从url上获取用户信息并存储
    initData()

    const router = new VueRouter({
        base: '/pages',
        mode: 'hash',
        routes: [...options.routes],
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition && to.meta.keepAlive) {
                return savedPosition
            }
            return { x: 0, y: 0 }
        },
    })

    router.beforeEach(async (to, from, next) => {
        // TODO: 添加白色背景色
        removeTheme()
        !JSBridge && NProgress.start()
        // 存在 title 则设置 title
        if (to.meta.title) {
            document.title = to.meta.title
            if (thsI18NJsBridge.isTHSI18NApp()) {
                thsI18NJsBridge.changeWebViewTitle(to.meta?.title)
            }
            JSBridge && JSBridge.setTitle(to.meta.title)
        }

        // 需要登录，且不在网厅，登录后更新用户信息
        if (to.matched.some(page => page.meta.login) && !from.name && getRunEnv() != 2) {
            if (JSBridge) {
                await store.dispatch('user/login')
            } else {
                store.dispatch('app/setNav', 'show')
                if (thsI18NJsBridge.isTHSI18NApp() || isTHSApp()) {
                    await store.dispatch('user/checkI18nThsAuthorization')
                }
                await store.dispatch('user/getClientInfo')
            }
        }
        if (options.handleBeforeEach) {
            options.handleBeforeEach(to, from, next)
        } else {
            next()
        }
    })

    let routerLength = 0 //vue 路由历史长度
    let showClosed = false //app是否已显示关闭按钮
    let lastHistoryLength = 0 //history 长度缓存

    router.afterEach((to, from, failure) => {
        !JSBridge && NProgress.done()
        if (!lastHistoryLength) {
            routerLength += 1
        } else {
            if (history.length > lastHistoryLength) {
                routerLength += 1
            }
        }
        lastHistoryLength = history.length
        //判断历史路由长度并显示app关闭按钮
        if (!showClosed && routerLength > 1) {
            JSBridge && JSBridge.setClose(true)
            thsI18NJsBridge.isTHSI18NApp() && thsI18NJsBridge.showCloseBarItem()
            showClosed = true
        }
        options.handleAfterEach && options.handleAfterEach(to, from, failure)
    })

    return router
}

function initData() {
    let searchQuery = {}
    if (window.location.search) {
        searchQuery = qs.parse(window.location.search?.split('?')[1])
    }
    if (window.location.hash) {
        searchQuery = qs.parse(window.location.hash?.split('?')[1])
    }
    let { nav } = searchQuery
    const { wtToken, sub, name } = searchQuery
    nav = isWeiXin() || isQQBrowser() || isDingtalk() || isHLApp() || isTHSApp() ? '0' : nav

    if (wtToken) {
        if (!JSBridge) {
            store.dispatch('user/clearUserInfo')
        }
        store.dispatch('user/setWTToken', wtToken)
    }
    if (sub) {
        store.dispatch('user/setSubAccountId', sub)
    }
    if (name) {
        store.dispatch('user/setWTuserName', name)
    }
    if (nav) {
        const navValue = nav == '0' ? 'hide' : 'show'
        store.dispatch('app/setNav', navValue)
    }
}
